const appendRouter = {
  // 课程
  "/course": [
    {
      path: "/p/course/guide",
      component: () => import("@/views/course/guide"),
      name: "guide",
      meta: { title: "课程管理" },
    },
    {
      path: "/course/video/create",
      component: () => import("@/views/course/createCourse"),
      name: "createCourse",
      meta: { title: "新建课程", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/audio/create",
      component: () => import("@/views/course/createCourse"),
      name: "createAudio",
      meta: { title: "新建音频", prefix: "/course/audio" },
      hidden: true,
    },
    {
      path: "/course/richtext/create",
      component: () => import("@/views/course/createCourse"),
      name: "createRichtext",
      meta: { title: "新建图文", prefix: "/course/richtext" },
      hidden: true,
    },
    {
      path: "/course/mixture/create",
      component: () => import("@/views/course/createCourse"),
      name: "createMixture",
      meta: { title: "新建组合课", prefix: "/course/mixture" },
      hidden: true,
    },
    {
      path: "/course/video/manage",
      component: () => import("@/views/course/courseManage"),
      name: "videoManage",
      meta: { title: "课程管理", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/audio/manage",
      component: () => import("@/views/course/courseManage"),
      name: "audioManage",
      meta: { title: "课程管理", prefix: "/course/audio" },
      hidden: true,
    },
    {
      path: "/course/richtext/manage",
      component: () => import("@/views/course/courseManage"),
      name: "richtextManage",
      meta: { title: "课程管理", prefix: "/course/richtext" },
      hidden: true,
    },
    {
      path: "/course/mixture/manage",
      component: () => import("@/views/course/courseManage"),
      name: "mixtureManage",
      meta: { title: "课程管理", prefix: "/course/mixture" },
      hidden: true,
    },
    {
      path: "/course/video/poster",
      component: () => import("@/views/course/poster"),
      name: "videoPoster",
      meta: { title: "课程海报", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/video/playbill",
      component: () => import("@/views/course/playbill"),
      name: "videoPlaybill",
      meta: { title: "课程海报", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/activity/sort",
      component: () => import("@/views/course/activity"),
      name: "activitySort",
      meta: { title: "课程排序", prefix: "/course" },
      hidden: true,
    },
  ],

  // 教学管理
  "/teach": [],

  // 用户管理
  "/user": [
    {
      path: "/user/detail",
      component: () => import("@/views/user/userDetail"),
      name: "userDetail",
      meta: { title: "用户详情", prefix: "/user/index" },
      hidden: true,
    },
    {
      path: "/groups/autoreply",
      component: () => import("@/views/user/groupAutoReply"),
      name: "groupAutoReply",
      meta: { title: "自动回复", prefix: "/user/groups" },
      hidden: true,
    },
  ],

  // 数据中心
  "/database": [],

  // 营销工具
  "/marketing": [
    {
      path: "/marketing/coupon/add",
      component: () => import("@/views/marketing/addCoupon"),
      name: "addCoupon",
      meta: { title: "添加优惠券", prefix: "/marketing/coupon" },
      hidden: true,
    },
    {
      path: "/marketing/coupon/code",
      component: () => import("@/views/marketing/couponCode"),
      name: "couponCode",
      meta: { title: "领取优惠券列表", prefix: "/marketing/coupon" },
      hidden: true,
    },
    {
      path: "/marketing/limited/create",
      component: () => import("@/views/marketing/limitedEdit"),
      name: "addLimited",
      meta: { title: "新建限时抢购", prefix: "/marketing/limited" },
      hidden: true,
    },
    {
      path: "/marketing/limited/edit",
      component: () => import("@/views/marketing/limitedEdit"),
      name: "editLimited",
      meta: { title: "编辑限时抢购", prefix: "/marketing/limited" },
      hidden: true,
    },
    {
      path: "/marketing/group",
      component: () => import("@/views/marketing/group"),
      name: "group",
      meta: { title: "拼团" },
    },
    {
      path: "/marketing/group/create",
      component: () => import("@/views/marketing/groupEdit"),
      name: "addGroup",
      meta: { title: "创建拼团" },
    },
    {
      path: "/marketing/group/edit",
      component: () => import("@/views/marketing/groupEdit"),
      name: "editGroup",
      meta: { title: "编辑拼团" },
    },
    {
      path: "/marketing/course",
      component: () => import("@/views/marketing/course"),
      name: "marketingCourse",
      meta: { title: "买课送课" },
    },
    {
      path: "/marketing/course/create",
      component: () => import("@/views/marketing/courseEdit"),
      name: "addCourse",
      meta: { title: "创建买课送课" },
    },
    {
      path: "/marketing/course/edit",
      component: () => import("@/views/marketing/courseEdit"),
      name: "editCourse",
      meta: { title: "编辑买课送课" },
    },
    {
      path: "/marketing/packet",
      component: () => import("@/views/marketing/packet"),
      name: "packet",
      meta: { title: "套餐" },
    },
    {
      path: "/marketing/packet/create",
      component: () => import("@/views/marketing/packetEdit"),
      name: "addPacket",
      meta: { title: "创建套餐" },
    },
    {
      path: "/marketing/packet/edit",
      component: () => import("@/views/marketing/packetEdit"),
      name: "editPacket",
      meta: { title: "编辑套餐" },
    },
    {
      path: "/marketing/page",
      component: () => import("@/views/marketing/page"),
      name: "editPacket",
      meta: { title: "编辑套餐" },
    },
    {
      path: "/marketing/page",
      component: () => import("@/views/marketing/page"),
      name: "editPacket",
      meta: { title: "店铺装修" },
    },
    {
      path: "/marketing/code",
      component: () => import("@/views/marketing/code"),
      name: "marketingCode",
      meta: { title: "兑换码" },
    },
    {
      path: "/planet/editPlanet",
      component: () => import("@/views/planet/editPlanet"),
      name: "editPlanet",
      meta: { title: "星球编辑", prefix: "/editPlanet" },
    },
    {
      path: "/p/planet/editPlanet",
      component: () => import("@/views/planet/editPlanet"),
      name: "editPlanet",
      meta: { title: "星球编辑", prefix: "/editPlanet" },
    },
    {
      path: "/planet/detail",
      name: "planetDetail",
      component: (resolve) => require(["@/views/planet/detail"], resolve),
      children: [
        {
          path: "/planet/configs",
          name: "planetConfigs",
          component: (resolve) =>
            require(["@/views/planet/views/configs"], resolve),
        },
        {
          path: "/planet/active",
          name: "planetActive",
          component: (resolve) =>
            require(["@/views/planet/views/active"], resolve),
        },
        {
          path: "/planet/columns",
          name: "planetColumns",
          component: (resolve) =>
            require(["@/views/planet/views/columns"], resolve),
        },
        {
          path: "/planet/cards",
          name: "planetCards",
          component: (resolve) =>
            require(["@/views/planet/views/cards"], resolve),
        },
        {
          path: "/planet/cards/punchcardList",
          name: "planetPunchcardList",
          component: (resolve) =>
            require(["@/views/planet/views/punchcardList"], resolve),
        },
        {
          path: "/planet/homework",
          name: "planetHomework",
          component: (resolve) =>
            require(["@/views/planet/views/homework"], resolve),
        },
        {
          path: "/planet/homework/homeworkList",
          name: "planetHomeworkList",
          component: (resolve) =>
            require(["@/views/planet/views/homeworkList"], resolve),
        },
        {
          path: "/planet/ask",
          name: "planetAsk",
          component: (resolve) =>
            require(["@/views/planet/views/ask"], resolve),
        },
        {
          path: "/planet/member",
          name: "planetMember",
          component: (resolve) =>
            require(["@/views/planet/views/member"], resolve),
        },
        {
          path: "/planet/data",
          name: "planetData",
          component: (resolve) =>
            require(["@/views/planet/views/data"], resolve),
        },
        {
          path: "/planet/tags",
          name: "admPlanetTags",
          component: (resolve) =>
            require(["@/views/planet/views/tags"], resolve),
        },
        {
          path: "/planet/menus",
          name: "admPlanetMenus",
          component: (resolve) =>
            require(["@/views/planet/views/menus"], resolve),
        },
        {
          path: "/planet/setting",
          name: "planetSetting",
          component: (resolve) =>
            require(["@/views/planet/views/setting"], resolve),
        },
      ],
    },
    {
      path: "/p/planet/detail",
      name: "planetDetail",
      component: (resolve) => require(["@/views/planet/detail"], resolve),
      children: [
        {
          path: "/p/planet/configs",
          name: "planetConfigs",
          component: (resolve) =>
            require(["@/views/planet/views/configs"], resolve),
        },
        {
          path: "/p/planet/active",
          name: "planetActive",
          component: (resolve) =>
            require(["@/views/planet/views/active"], resolve),
        },
        {
          path: "/p/planet/columns",
          name: "planetColumns",
          component: (resolve) =>
            require(["@/views/planet/views/columns"], resolve),
        },
        {
          path: "/p/planet/cards",
          name: "planetCards",
          component: (resolve) =>
            require(["@/views/planet/views/cards"], resolve),
        },
        {
          path: "/p/planet/cards/punchcardList",
          name: "planetPunchcardList",
          component: (resolve) =>
            require(["@/views/planet/views/punchcardList"], resolve),
        },
        {
          path: "/p/planet/homework",
          name: "planetHomework",
          component: (resolve) =>
            require(["@/views/planet/views/homework"], resolve),
        },
        {
          path: "/p/planet/homework/homeworkList",
          name: "planetHomeworkList",
          component: (resolve) =>
            require(["@/views/planet/views/homeworkList"], resolve),
        },
        {
          path: "/p/planet/ask",
          name: "planetAsk",
          component: (resolve) =>
            require(["@/views/planet/views/ask"], resolve),
        },
        {
          path: "/p/planet/member",
          name: "planetMember",
          component: (resolve) =>
            require(["@/views/planet/views/member"], resolve),
        },
        {
          path: "/p/planet/data",
          name: "planetData",
          component: (resolve) =>
            require(["@/views/planet/views/data"], resolve),
        },
        {
          path: "/p/planet/tags",
          name: "admPlanetTags",
          component: (resolve) =>
            require(["@/views/planet/views/tags"], resolve),
        },
        {
          path: "/p/planet/menus",
          name: "admPlanetMenus",
          component: (resolve) =>
            require(["@/views/planet/views/menus"], resolve),
        },
        {
          path: "/p/planet/setting",
          name: "planetSetting",
          component: (resolve) =>
            require(["@/views/planet/views/setting"], resolve),
        },
      ],
    },
  ],

  // 订单管理
  "/order": [
    {
      path: "/order/manage",
      component: () => import("@/views/order/manage"),
      name: "orderManage",
      meta: { title: "抖店订单" },
    },
  ],

  // 售后管理
  "/aftersale": [
    {
      path: "/aftersale/detail",
      component: () => import("@/views/aftersale/detail"),
      name: "aftersaleDetail",
      meta: { title: "售后详情", prefix: "/aftersale/index" },
      hidden: true,
    },
  ],

  // 资金收益
  "/accounting": [
    {
      path: "/accounting/balance/person",
      component: () => import("@/views/accounting/personIndentify"),
      name: "personIndentify",
      meta: { title: "个人账户认证", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/balance/company",
      component: () => import("@/views/accounting/companyIndentify"),
      name: "companyIndentify",
      meta: { title: "企业及个体户认证", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/balance/cash",
      component: () => import("@/views/accounting/extractCash"),
      name: "balanceCash",
      meta: { title: "申请转出", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/extractCash",
      component: () => import("@/views/accounting/cash"),
      name: "extractCash",
      meta: { title: "申请转出", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/extractCashSuccess",
      component: () => import("@/views/accounting/extractCashSuccess"),
      name: "extractCashSuccess",
      meta: { title: "转出成功", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/hybridExtractCash",
      component: () => import("@/views/accounting/hybridExtractCash"),
      name: "hybridExtractCash",
      meta: { title: "申请转出", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/balance/indentify",
      component: () => import("@/views/accounting/indentify"),
      name: "indentify",
      meta: { title: "帐户认证", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/income/detail",
      component: () => import("@/views/accounting/detail"),
      name: "incomeDetail",
      meta: { title: "收入明细", prefix: "/accounting/income" },
      hidden: true,
    },
  ],

  // 系统设置
  "/setting": [
    {
      path: "/setting/index",
      component: () => import("@/views/setting/index"),
      name: "zizhi",
      meta: { title: "抖音资质", prefix: "/setting" },
      hidden: true,
    },
    {
      path: "/setting/self",
      component: () => import("@/views/setting/self"),
      name: "accountingSelf",
      meta: { title: "账号设置", prefix: "/setting" },
      hidden: true,
    },
    {
      path: "/setting/accounting/add",
      component: () => import("@/views/setting/addAccounting"),
      name: "addAccounting",
      meta: { title: "添加员工", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/setting/accounting/edit",
      component: () => import("@/views/setting/editAccounting"),
      name: "editAccounting",
      meta: { title: "编辑员工", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/setting/accounting/qualification",
      component: () => import("@/views/setting/qualification"),
      name: "qualification",
      meta: { title: "资质认证", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/setting/myRoleApply",
      component: () => import("@/views/setting/roleApply"),
      name: "roleApply",
      meta: { title: "角色申请" },
    },
    {
      path: "/setting/roleBaseInfoApply",
      component: () => import("@/views/setting/roleBaseInfoApply"),
      name: "roleBaseInfoApply",
      meta: { title: "角色基础申请" },
    },
    {
      path: "/setting/roleClassInfoApply",
      component: () => import("@/views/setting/roleClassInfoApply"),
      name: "roleClassInfoApply",
      meta: { title: "角色类目申请" },
    },
    {
      path: "/setting/roleAuthInfoApply",
      component: () => import("@/views/setting/roleAuthInfoApply"),
      name: "roleAuthInfoApply",
      meta: { title: "角色授权申请" },
    },
    {
      path: "/setting/ttScope",
      component: () => import("@/views/setting/ttScope"),
      name: "ttScope",
      meta: { title: "抖音账号管理" },
    },
    {
      path: "/setting/teacher/information",
      component: () => import("@/views/setting/information"),
      name: "information",
      meta: { title: "认证讲师" },
    },
    {
      path: "/setting/teacher/identificationApply",
      component: () => import("@/views/setting/identificationApply"),
      name: "identificationApply",
      meta: { title: "完善讲师认证资料" },
    },
    {
      path: "/setting/teacher/IdentificationSuccess",
      component: () => import("@/views/setting/IdentificationSuccess"),
      name: "IdentificationSuccess",
      meta: { title: "讲师认证审核" },
    },
    {
      path: "/setting/guide",
      component: () => import("@/views/setting/guide"),
      name: "guide",
      meta: { title: "入驻引导" },
    },
    // {
    //   path: "/setting/accounting/teacher",
    //   component: () => import("@/views/setting/teacher"),
    //   name: "teacherQualification",
    //   meta: { title: "讲师认证", prefix: "/setting/accounting" },
    //   hidden: true,
    // },
    // {
    //   path: "/setting/accounting/company",
    //   component: () => import("@/views/setting/company"),
    //   name: "companyQualification",
    //   meta: { title: "讲师认证", prefix: "/setting/accounting" },
    //   hidden: true,
    // },
    {
      path: "/setting/enterpriseBaseInfoApply",
      component: () => import("@/views/setting/enterpriseBaseInfoApply"),
      name: "enterpriseBaseInfoApply",
      meta: { title: "企业角色基础申请" },
    },
    {
      path: "/setting/enterpriseClassInfoApply",
      component: () => import("@/views/setting/enterpriseClassInfoApply"),
      name: "enterpriseClassInfoApply",
      meta: { title: "企业类目申请" },
    },
    {
      path: "/setting/enterpriseAuthInfoApply",
      component: () => import("@/views/setting/enterpriseAuthInfoApply"),
      name: "enterpriseAuthInfoApply",
      meta: { title: "企业角色授权申请" },
    },
  ],
};

export const appendRouterMap = appendRouter;
